import { render, staticRenderFns } from "./DocumentPOSPartner.vue?vue&type=template&id=93facc66"
import script from "./DocumentPOSPartner.vue?vue&type=script&lang=js"
export * from "./DocumentPOSPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports